module.exports = function() {
  return new Worker(__webpack_public_path__ + "17a35f2c4f8217a714ec.worker.js");
};